import HTTP_METHODS from "src/general/constants/http/httpMethods";
import validateStatus from "src/business.InterfaceLayer/store/services/utils.service/validateStatus";

const removeLastCharacter = (inputString: string): string => {
	if (inputString.length > 0) {
		if (inputString.charAt(inputString.length - 1) === "/") {
			return inputString.slice(0, -1);
		}
	}
	return inputString;
};

export const getApiUrl = <Path extends string>(
	base: Path,
	path: string,
	pathArg?: string
) =>
	removeLastCharacter(
		`${base}${path.startsWith("/") ? path : `/${path}`}${
			pathArg ? `/${pathArg}` : ""
		}`
	);

export const getQueryParams = <T extends object>(
	params: T | undefined
): Record<string, any> | undefined => {
	if (!params) return;

	const obj = { ...params };

	Object.keys(obj).forEach((key) =>
		obj[key as keyof T] === undefined ? delete obj[key as keyof T] : {}
	);
	if (Object.keys(obj).length > 0) return obj;

	return;
};

export const createBaseQueryDefinition = <
	MainPath extends string,
	Path extends string
>(
	method: HTTP_METHODS,
	mainPath: MainPath,
	transformResponseFn?: Function
) => {
	type GetRequestBaseArgs<Params extends object> = {
		path: Path;
		params?: Params;
		pathArg?: string;
		doNotTransform?: boolean;
	};

	return <Params extends object = any>({
		path,
		pathArg,
		params,
		doNotTransform = false,
	}: GetRequestBaseArgs<Params>) => ({
		url: getApiUrl<MainPath>(mainPath, path, pathArg),
		params: getQueryParams<Params>(params),
		method: method,
		validateStatus,
		transformResponse: doNotTransform ? undefined : transformResponseFn,
	});
};
